import { IsMandatory,
  RemoveTypeFromRule,
  SchemaClass } from '@/utils/validator/decorators/decorator.types';
import updateSchema from '@/utils/validator/decorators/utils/update-schema';

export default function decoratorFactory<T extends object>(mandatory: Partial<RemoveTypeFromRule<T>> = {}) {
  return function (...options: IsMandatory<RemoveTypeFromRule<T>>) {
    return (target: SchemaClass, key: string): any => {
      updateSchema(target.constructor.prototype as typeof SchemaClass, key, { ...options[0], ...mandatory });
    };
  };
}
